class FormNavigation {
    constructor(heroFormWrap, formNavWrapper, stepWrap, nextStep, backStep) {
        this.heroFormWrap = heroFormWrap;
        this.formNavWrapper = formNavWrapper;
        this.stepWrap = stepWrap;
        this.nextStep = nextStep;
        this.backStep = backStep;
    }
    setClassToFileLabel() {
        const heroFormWrap = document.querySelector(this.heroFormWrap);
        let fileInput = heroFormWrap.querySelectorAll('input[type="file"]');
        if (fileInput) {
            fileInput = Array.prototype.slice.call(fileInput);
            fileInput.forEach(element => {
                const inputLabel = element.parentNode.parentNode;
                if (inputLabel.tagName === "LABEL") {
                    inputLabel.classList.add("file-label");
                }
            });
        }
    }
    setFormWrapHeight() {
        // set height for the form and step-wraps because they are absolutely positioned
        const heroFormWrap = document.querySelector(this.heroFormWrap);

        if (heroFormWrap) {
            const form = heroFormWrap.querySelector("form");
            let stepWraps = heroFormWrap.querySelectorAll(this.stepWrap);
            const stepWrapsArr = Array.prototype.slice.call(stepWraps);
            const heightArr = stepWrapsArr.map(element => {
                return element.offsetHeight;
            });
            const formHeight = heightArr.reduce((a, b) => {
                return a > b ? a : b;
            }, 0);
            if (stepWraps) {
                stepWraps = Array.prototype.slice.call(stepWraps);
                stepWraps.forEach(item => {
                    item.style.height = formHeight + "px";
                });
                form.style.height = formHeight + "px";
            }
        }
    }
    navigateToStep(e) {
        const stepBtn = e.currentTarget;
        const activeStepName = stepBtn.innerHTML;
        const activeStepItem = stepBtn.parentNode;
        const formNavWrapper = document.querySelector(this.formNavWrapper);
        let stepItems = formNavWrapper.querySelectorAll("li");
        const heroFormWrap = document.querySelector(this.heroFormWrap);
        let stepWraps = heroFormWrap.querySelectorAll(this.stepWrap);
        const numberOfItems = stepWraps.length;
        const button = document.querySelector(this.nextStep);
        const buttonBack = document.querySelector(this.backStep);

        // remove is-active class from step nav items and add/remove the is-hidden class from "next" button
        if (stepItems) {
            stepItems = Array.prototype.slice.call(stepItems);
            stepItems.forEach((element, index) => {
                if (element.classList.contains("is-active")) {
                    element.classList.remove("is-active");
                }
                if (
                    stepBtn.parentNode === element &&
                    index === numberOfItems - 1
                ) {
                    button.classList.add("is-hidden");
                } else {
                    button.classList.remove("is-hidden");
                }

             
                
            });
        }

       
        // add is active class to step nav items and step wraps4
        activeStepItem.classList.add("is-active");


        if (stepWraps) {
            stepWraps = Array.prototype.slice.call(stepWraps);
            stepWraps.forEach(element => {
                if (element.classList.contains("is-active")) {
                    element.classList.remove("is-active");
                    element.classList.add("is-inactive");
                    
                }
                const stepName = element.getAttribute("data-name");
                if (stepName === activeStepName) {
                    element.classList.add("is-active");
                }
            });

            if( (stepWraps[0]).classList.contains('is-active') ){
                buttonBack.classList.add('is-hidden');
            } else{
                buttonBack.classList.remove('is-hidden');
            }
           
        }
    }
    moveDownAStep(e) {
        const button = e.currentTarget;
        const backBtn = document.querySelector(this.backStep);
        const heroFormWrap = document.querySelector(this.heroFormWrap);
        const formNavWrapper = heroFormWrap.querySelector(this.formNavWrapper);
        let listItem = formNavWrapper.querySelectorAll("li");
        let stepWrap = heroFormWrap.querySelectorAll(this.stepWrap);
        const numberOfItems = stepWrap.length;
        let activeButton;
        if (stepWrap) {
            stepWrap = Array.prototype.slice.call(stepWrap);
        }
        if (stepWrap) {
            stepWrap.forEach(element => {
                if (element.classList.contains("is-active")) {
                    activeButton = element;
                }
            });
        }

        const activeIndex = [...stepWrap].indexOf(activeButton);
        const nextActiveIndex = activeIndex + 1;

        // hide the next button if we reach the last item
        if (nextActiveIndex === numberOfItems - 1) {
            button.classList.add("is-hidden");
        } else {
            backBtn.classList.remove('is-hidden');
            if (button.classList.contains("is-hidden")) {
                button.classList.remove("is-hidden");
                
            }
        }

        // add is active class to the next step wrap item
        if (stepWrap) {
            stepWrap.forEach((element, index) => {
                if (index === activeIndex) {
                    console.log(true);
                    element.classList.remove("is-active");
                    element.classList.add("is-inactive");
                }
                if (index === nextActiveIndex) {
                    element.classList.add("is-active");
                    element.classList.remove("is-inactive");
                }
            });
        }

        // add is active class to the next nav item
        if (listItem) {
            listItem = Array.prototype.slice.call(listItem);
            listItem.forEach((element, index) => {
                if (index === activeIndex) {
                    element.classList.remove("is-active");
                    element.classList.add("is-inactive");
                }
                if (index === nextActiveIndex) {
                    element.classList.add("is-active");
                    element.classList.remove("is-inactive");
                }
            });
        }
    }

    moveBackStep(e){
        const button = e.currentTarget;
        const nextBtn = document.querySelector(this.nextStep);
        const heroFormWrap = document.querySelector(this.heroFormWrap);
        const formNavWrapper = heroFormWrap.querySelector(this.formNavWrapper);
        let listItem = formNavWrapper.querySelectorAll("li");
        let stepWrap = heroFormWrap.querySelectorAll(this.stepWrap);
        const numberOfItems = stepWrap.length;
        let activeButton;
        if (stepWrap) {
            stepWrap = Array.prototype.slice.call(stepWrap);
        }
        if (stepWrap) {
            stepWrap.forEach(element => {
                if (element.classList.contains("is-active")) {
                    activeButton = element;
                }
            });
        }

        const activeIndex = [...stepWrap].indexOf(activeButton);
        const prevActiveIndex = activeIndex - 1;

        // hide the back button if we are at beginning
        if (prevActiveIndex === 0 ) {
            button.classList.add("is-hidden");
            nextBtn.classList.remove('is-hidden');
        } else {
            nextBtn.classList.remove('is-hidden');
            if (button.classList.contains("is-hidden")) {
                button.classList.remove("is-hidden");
            }

        }

        // add is active class to the prev step wrap item
        if (stepWrap) {
            stepWrap.forEach((element, index) => {
                if (index === activeIndex) {
                    console.log(true);
                    element.classList.remove("is-active");
                    element.classList.add("is-inactive");
                }
                if (index === prevActiveIndex) {
                    element.classList.add("is-active");
                    element.classList.remove("is-inactive");
                }
            });
        }

        // add is active class to the prev nav item
        if (listItem) {
            listItem = Array.prototype.slice.call(listItem);
            listItem.forEach((element, index) => {
                if (index === activeIndex) {
                    element.classList.remove("is-active");
                    element.classList.add("is-inactive");
                }
                if (index === prevActiveIndex) {
                    element.classList.add("is-active");
                    element.classList.remove("is-inactive");
                }
            });
        }
    }
    init() {
        const heroFormWrap = document.querySelector(this.heroFormWrap);

        if (heroFormWrap) {
            const formNavWrapper = heroFormWrap.querySelector(
                this.formNavWrapper
            );
            let stepWrap = heroFormWrap.querySelectorAll(this.stepWrap);
            const stepList = document.createElement("ul");
            const nextStep = document.querySelector(this.nextStep);
            const backStep = document.querySelector(this.backStep);
            stepList.classList.add("form-nav");

            // create a form navigation by using data-name attributes in step wraps
            if (stepWrap) {
                stepWrap = Array.prototype.slice.call(stepWrap);
                stepWrap.forEach((element, index) => {
                    const stepName = element.getAttribute("data-name");
                    const stepListItem = document.createElement("li");
                    const stepButton = document.createElement("button");
                    const buttonText = document.createTextNode(stepName);
                    if (index === 0) {
                        stepListItem.classList.add("is-active");
                        element.classList.add("is-active");
                    }
                    else {
                        element.classList.add("is-inactive");
                    }
                    stepButton.appendChild(buttonText);
                    stepListItem.appendChild(stepButton);
                    stepList.appendChild(stepListItem);

                    // add event listeners to form navigation buttons
                    stepButton.addEventListener("click", e => {
                        this.navigateToStep(e);
                    });
                });
                formNavWrapper.appendChild(stepList);
                this.setClassToFileLabel();
            }

            // add event listener to next step button
            if (nextStep) {
                nextStep.addEventListener("click", e => {
                    this.moveDownAStep(e);
                });
            }

            if (backStep) {
                backStep.addEventListener("click", e=>{
                    this.moveBackStep(e);
                });
            }
        }
    }
}

export default new FormNavigation(
    ".hero-form-wrap",
    ".form-nav-wrapper",
    ".step-wrap",
    ".next-step",
    ".back-step"
);
